import { api } from '@goaltree/backend/convex/_generated/api'
import { useQuery } from 'convex/react'
import { useEffect, useRef } from 'react'

import { readSnapshot, writeSnapshot } from '@/lib/offline-cache'

const GOALS_CACHE_KEY = 'goals'

export function useGoals() {
  const live = useQuery(api.nodes.getUserGoals)

  // Persist the last good payload; render it when the network is down so the
  // goals list doesn't collapse to a spinner offline.
  const cachedRef = useRef<typeof live>(undefined)
  if (cachedRef.current === undefined)
    cachedRef.current = readSnapshot(GOALS_CACHE_KEY) ?? undefined
  useEffect(() => {
    if (live !== undefined && live !== null) {
      writeSnapshot(GOALS_CACHE_KEY, live)
      cachedRef.current = live
    }
  }, [live])

  return live ?? cachedRef.current
}
